export default function isPlainObject(item) {
  return Boolean(item) && typeof item == 'object' && item.constructor == Object;
}
